export const nameSpaces = {
  NS_RESULT: 'result',
  NS_SESSION: 'session',
  NS_FORM: 'form',
  NS_VO: 'vo',
  NS_VO_ASSIGNEE: 'vo-assignee',
  NS_VO_CREATOR: 'vo-creator',
  NS_TASK: 'task',
  NS_TASK_ASSIGNEE: 'task-assignee',
  NS_TASK_CREATOR: 'task-creator',
  NS_TASK_PARTICIPANTS: 'task-participants',
  NS_TASK_VOS: 'task-vos',
  NS_REFERRAL: 'referral',
};

export const defaultEvaluateConfig = {
  gracefullyExecute: 'true',
  nullOnError: 'true',
  retainOutput: 'true',
};
